import Component from './TikTokAnalyticsPublicSummary.vue'
export default Component
